import * as React from 'react';
import { Box, IconButton, Slide } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import Modal from '@mui/material/Modal';

const style = {
  margin: '52px auto 0',
  width: '100%',
  borderRadius: '12px 12px 0px 0px',
  bgcolor: 'background.paper',
  maxWidth: '600px',
  boxSizing: 'border-box',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100% - 52px)',
};

export default function SystemLogsModal({
  open,
  content,
  onClose,
  ...props
}) {
  return (
    <Modal
      {...props}
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      keepMounted
      closeAfterTransition
    >
      <Slide direction='up' in={open} timeout={200}>
        <Box sx={style}>
          <Box sx={{ padding: '8px' }}>
            <IconButton color='inherit' aria-label='back' onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <pre style={{ padding: '0 20px 40px 20px', flex: 1, overflow: 'auto', wordBreak: 'break-all', whiteSpace: 'pre-wrap' }}>{content}</pre>
        </Box>
      </Slide>
  </Modal>
  );
}